import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSouthWest = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.5 19V9H6.5V15.6L18.1 4L19.5 5.4L7.9 17H14.5V19H4.5Z",
		fill: "currentColor"
	})
});
export default SvgSouthWest;
